import { useQueryClient } from 'react-query'
import { WorkcenterListDataType, WorkcenterListType } from './hooks.types'
import { useWorkcentreList } from 'Features/WorkCentreSummary/WorkCentreSummary.data'
// This hook look for workcenter-list data in the query cache, if it exists ,
// it would return cached data. Otherwise it would fetch data fron the back end,
export const useWorkcentreKPIs = (planId: string, workcentreId: string) => {
  const queryClient = useQueryClient()
  const params = ['workcentre-list', planId]
  const cachedData = queryClient.getQueryData<WorkcenterListDataType>(params)
  const { data } = useWorkcentreList(planId, cachedData ? false : true)

  if (cachedData) {
    return (
      cachedData.data?.filter((wc: WorkcenterListType) => {
        return wc.workCentreKey == Number(workcentreId)
      }) ?? [undefined]
    )
  }

  return (
    data?.data?.filter(
      (wc: WorkcenterListType) => wc.workCentreKey == Number(workcentreId)
    ) ?? [undefined]
  )
}
